module.exports = __webpack_public_path__ + "img/t_sport.53f6157.webp";